import i18next from "i18next"
import * as React from "react"
import { Entity } from "ts-lenses"
import { mkWidget, route } from "widgets-for-react"
import { CustomRouteParams } from "../../../cms/router/type.gen"
import { PublicSiteState } from "../../../public_site.main.mod"
import { CustomPage, CustomPagesState, PublicSiteCustomRoutes } from "../types.mod"
import { initBeslismatrixFormState } from "./beslismatrixWizardState"
import { beslismatrixWizardWidget } from "./beslismatrixWizardWidget"

export const beslismatrixPage: CustomPage<CustomPagesState["form"]> = {
  widget: (r) =>
    mkWidget({
      run: (set_state) => {

        let beslismatrixFormState = r.snd.state

        return (<>
          <article className="page page--form">
            <div className="block block--small">
              <div className="text--styled">
                {i18next.t('Beslismatrix.Intro_Text')}
              </div>
            </div>

            <div className="block block--small">
              <div className="hero__inner">
                {beslismatrixWizardWidget(beslismatrixFormState).run(a => set_state((s1) => ({ ...s1, state: a(s1.state) })))}
              </div>
            </div>
          </article >
        </>
        )
      }
    }),

  route: route<{}, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>("/test/form", (s) => ({
    kind: "form",
  })),

  getState: (s: PublicSiteState) => s.form,
  setState: (s: PublicSiteState, ss: CustomPagesState["form"]) => {
    let res = Entity(s)
      .set("form", (os) => ss)
      .commit()
    return res
  },

  updateStateBasesOnRoute: (globalState, routeParams) => {
    if (routeParams.kind != "form") return globalState

    return { ...globalState, form: { state: initBeslismatrixFormState() } }
  },
}
